<template>
    <div class="row">
        <div class="col-12">
            <div class="col-12">
                <h1 class="title-tab-content">جلسات عملی رانندگی</h1>
            </div>
            <div class="content-section default">

                <div class="content-section default">
                    <div method="get" class="profile-return-request-form">

                        <div class="profile-return-request-form-row">
                            <div class="row">
                                <div class="col-lg-2 col-md-12 col-12 margin-t-10 " v-if="userGroupId == 2">
                                    <span> مربی  </span>

                                    <select class="form-control border-radius-5 margin-t-5" v-model="selectedEducatorId">
                                        <option value="0">همه</option>
                                        <option v-for="(educator,index) in educators" :value="educator.Value">{{ educator.Text }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-2 col-md-12 col-12 margin-t-10">
                                    <div class="profile-return-request-form-field">
                                        <span>از تاریخ </span>
                                        <div class="margin-t-5">
                                            <custom-date-picker v-model="fromDate" class="margin-t-5"></custom-date-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-2 col-md-12 col-12 margin-t-10">
                                    <div class="profile-return-request-form-field">
                                        <span>تا تاریخ </span>
                                        <div class="margin-t-5">
                                            <custom-date-picker v-model="toDate"></custom-date-picker>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-2 col-md-12 col-12 margin-t-10">
                                    <span>نمایش: </span>
                                    <div class="margin-t-5">
                                        <select v-model="viewMode" class="form-control border-radius-5 margin-t-5">
                                            <option value="card">بصورت کارت</option>
                                            <option value="table">بصورت جدول</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-12 col-12 margin-t-10">
                                    <div class="profile-return-request-form-button profile-return-request-form-button-top-btn " style="margin-top:20px;">
                                        <button type="button" @click="applyFilter" class="btn-primary" style="margin-left:10px;">نمایش</button>
                                        <button type="button" @click="exportEduDrvSessionPdfReport" class="btn-primary">خروجی PDF</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-section default" v-if="eduDrvSessions.length > 0">
                    <div class="row" v-if="viewMode === 'table'">
                        <!--<h6 style="padding-right:10px;">نمایش اطلاعات</h6>-->
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" class="center-text">ردیف</th>
                                        <th v-if="userGroupId == 2" scope="col">مربی</th>
                                        <th scope="col" class="center-text">تاریخ شروع</th>
                                        <th scope="col" class="center-text">ساعت شروع</th>
                                        <th scope="col" class="center-text">نوع جلسه (شماره)</th>
                                        <th scope="col">هنرآموز</th>
                                        <th scope="col" class="center-text">وضعیت</th>
                                        <th scope="col">عملیات</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(eduDrvSession,index) in eduDrvSessions" :style="{ color: eduDrvSession.Status == 2 ? 'green' : (eduDrvSession.Status == 3? 'red': '')}">
                                        <th scope="row" class="center-text">{{ index+1 }}</th>
                                        <td v-if="userGroupId == 2">{{eduDrvSession.EduName}}</td>
                                        <td class="center-text">{{ eduDrvSession.SesStartDate_Solar }}</td>
                                        <td class="center-text">{{eduDrvSession.SesStartTime}}</td>
                                        <td class="center-text">{{ eduDrvSession.SesTypeExpr + ' (' + eduDrvSession.No +')' }}</td>
                                        <td>{{eduDrvSession.StdName }}</td>
                                        <td class="center-text">{{ eduDrvSession.StatusExpr }}</td>
                                        <td>
                                            <button type="button" @click="openeduDrvSessionDetailModal(eduDrvSession.DrvSesID)" class="btn btn-info btn-sm">جزئیات</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row" v-if="viewMode === 'card'">
                        <div v-for="(eduDrvSession, index) in eduDrvSessions" :key="index" class="col-12 col-md-6 col-lg-4 mb-4">
                            <div class="card" :style="{ borderColor: eduDrvSession.Status == 2 ? 'green' : (eduDrvSession.Status == 3 ? 'red' : '') }">
                                <div class="card-header">
                                    <h5 class="card-title" v-if="userGroupId == 2">{{ index + 1 }}. {{ eduDrvSession.EduName }}</h5>
                                    <h5 class="card-title" v-else>{{ index + 1 }}. {{ eduDrvSession.StdName }}</h5>
                                </div>
                                <div class="card-body">
                                    <p><strong>تاریخ شروع:</strong> {{ eduDrvSession.SesStartDate_Solar }}</p>
                                    <p><strong>ساعت شروع:</strong> {{ eduDrvSession.SesStartTime }}</p>
                                    <p><strong>نوع جلسه (شماره):</strong> {{ eduDrvSession.SesTypeExpr + ' (' + eduDrvSession.No + ')' }}</p>
                                    <p v-if="userGroupId == 2"><strong>هنرآموز:</strong> {{ eduDrvSession.StdName }}</p>
                                    <p><strong>وضعیت:</strong> {{ eduDrvSession.StatusExpr }}</p>
                                </div>
                                <div class="card-footer">
                                    <button type="button" @click="openeduDrvSessionDetailModal(eduDrvSession.DrvSesID)" class="btn btn-info btn-sm">جزئیات</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <!--<h6 style="padding-right:10px;">نمایش اطلاعات</h6>-->
                    <div class="col-12 text-center">
                        <div class="content-section pt-5 pb-5">
                            <div class="icon-empty">
                                <i class="now-ui-icons travel_info"></i>
                            </div>
                            <h1 class="text-empty">اطلاعاتی برای نمایش وجود ندارد!</h1>
                        </div>
                    </div>
                </div>


            </div>
        </div>
        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
        <eduDrvSessionDetails-Modal :eduDrvSessionDetail="eduDrvSessionDetail"></eduDrvSessionDetails-Modal>
    </div>
</template>
<script>
    import { baseUrl } from "../../../module/httpUtility";
    import { httpPromise } from "../../../module/httpUtility";
    import eduDrvSessionDetailsModal from "./eduDrvSessionDetailsModal.vue";
    export default {
        data() {
            return {
                eduDrvSessions: [],
                isShowSppiner: false,
                fromDate: '',
                toDate: '',
                educators: [],
                eduDrvSessionDetail: {},
                selectedEducatorId: 0,
                viewMode: 'card'
            }
        },
        components: {
            'eduDrvSessionDetails-Modal': eduDrvSessionDetailsModal,
        },
        created() {
            this.fromDate = this.currentDate;
            this.toDate = this.currentDate;
            this.readEduDrvSession();
            this.viewMode = this.userGroupId == 2 ? 'table' : 'card';
        },
        beforeMount: function () {
            createPageTitle('جلسات عملی رانندگی');
            this.readEducators();
        },

        computed: {
            currentDate: function () {
                return this.$store.getters.readCurrentDate;
            },
            userGroupId: function () {
                return this.$store.getters.readUserGroupId;
            },
        },


        methods: {

            openeduDrvSessionDetailModal(id) {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/Identities/EduDrvSession/Find', 'get', { drvSesID: id },
                    response => {
                        this.eduDrvSessionDetail = response.data.Value;
                        //alert(JSON.stringify(response.data.Value));
                        this.isShowSppiner = false;
                        $(function () {
                            $('#eduDrvSessionDetailsModal').modal({ backdrop: 'static', keyboard: true });
                            $('#eduDrvSessionDetailsModal').modal('show');
                        });
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },

            readEduDrvSession() {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/Identities/EduDrvSession/Read', 'get', { FromDate: this.currentDate, ToDate: this.currentDate, EducatorId: this.selectedEducatorId },
                    response => {
                        this.eduDrvSessions = response.data.Value;
                        this.isShowSppiner = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },

             

            exportEduDrvSessionPdfReport() { 
                this.isShowSppiner = true;
                const params = {
                    FromDate: this.fromDate,
                    ToDate: this.toDate,
                    EducatorId: this.selectedEducatorId
                };
                const url = baseUrl + '/Identities/EduDrvSession/GetReport';  
                const token = localStorage.getItem('accessToken');  

                fetch(url, {
                    method: 'POST',  
                    headers: {
                        'Authorization': 'Bearer ' + token,  
                        'Content-Type': 'application/json'   
                    },
                    body: JSON.stringify(params)  
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('خطا در دریافت فایل');
                        }
                        return response.blob(); 
                    })
                    .then(blob => {
                        //const fileURL = URL.createObjectURL(blob);
                        //window.open(fileURL, '_blank');
                        //this.isShowSppiner = false;
                        const fileURL = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = fileURL;
                        a.download = 'گزارش جلسات عملی آموزشگاه رانندگی معجزه' + '.pdf';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        this.isShowSppiner = false;
                    })
                    .catch(error => {
                        this.isShowSppiner = false;
                    });
            },

            readEducators() {
                httpPromise(this, '/v1/Identities/Educators/ReadForComboBox', 'get', {},
                    response => {
                        this.educators = response.data.Value;
                    },
                    response => {
                        toastr.remove();

                    });
            },



            applyFilter() {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/Identities/EduDrvSession/Read', 'get', { FromDate: this.fromDate, ToDate: this.toDate, EducatorId: this.selectedEducatorId },
                    response => {

                        this.eduDrvSessions = response.data.Value;
                        this.isShowSppiner = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },

        },
    }
</script>

<style scoped>
    .center-text {
        text-align: center;
    }


    .card {
        border: 1px solid;
    }

    .card-header {
        background-color: #f8f9fa;
        font-weight: bold;
    }

    .card-body {
        padding: 15px;
    }

    .card-footer {
        background-color: #f8f9fa;
        text-align: right;
    }
</style>